// client/src/coms/views/games_parts/avatarSources.js
// Voxemera avatars live at a predictable URL whether or not the user uploaded one; a missing one answers
// 404 and the UI falls back to initials. Games show the same players many times (lobby, seat strips,
// scoreboards, canvases), so a URL that failed once is not requested again in this page.
import { avatarUrlForUserId } from '../chatview_parts/chatUtils';

const failed = new Set();

export function avatarSrc(userId) {
  const src = avatarUrlForUserId(userId);
  return src && !failed.has(src) ? src : '';
}

export function markAvatarFailed(src) {
  if (src) failed.add(src);
}
